import { useI18n } from 'next-localization';
import { getAvailableTabs } from '@/store/fundDetails';
import { useSelector } from 'react-redux';
import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import { AvailableTabs } from '@/store/fundDetails/typings';
import FundDetailsBreakdownCreditProfileTable from './FundDetailsBreakdownCreditProfileTable';
import FundDetailsBreakdownSectorTable from './FundDetailsBreakdownSectorTable';
import FundDetailsBreakdownMaturityProfileTable from './FundDetailsBreakdownMaturityProfileTable';
import FundDetailsBreakdownCountryTable from './FundDetailsBreakdownCountryTable';

const FundDetailsBreakdownTab = () => {
  const { t } = useI18n();
  const availableTabs: AvailableTabs = useSelector(getAvailableTabs);
  const isTableEnabled = (tableKey: string) => {
    return !!availableTabs?.breakdownTab?.[tableKey];
  };
  return (
    <section className="default-section-padding background-white">
      <FundDetailsTabRow fullWidth>
        <h2>{t('fundDetailsTabsBreakdown')}</h2>
        <>
          {isTableEnabled('creditBreakdown') && <FundDetailsBreakdownCreditProfileTable />}
          {isTableEnabled('maturityBreakdown') && <FundDetailsBreakdownMaturityProfileTable />}
          {isTableEnabled('sectorBreakdown') && <FundDetailsBreakdownSectorTable />}
          {isTableEnabled('countryBreakdown') && <FundDetailsBreakdownCountryTable />}
        </>
      </FundDetailsTabRow>
    </section>
  );
};

export default FundDetailsBreakdownTab;
